/* eslint-disable */
import { createContext, useReducer, useContext } from "react";
import { initialState, rootReducer } from "./Store/RootReducer";

export const GlobalProvider = createContext();

const GlobalContext = (props) => {
  const [state, dispatch] = useReducer(rootReducer, initialState);

  return (
    <GlobalProvider.Provider
      value={{
        /*====== store requirements start ======= */
        state,
        dispatch,
        /*====== store requirements end ======= */
      }}
    >
      {props.children}
    </GlobalProvider.Provider>
  );
};

export default GlobalContext;

// custom hook
export const useGlobalContext = () => useContext(GlobalProvider);
